import { LayoutFooter, LayoutSubheader } from '../../_metronic';
import { IBreadcrumb } from '../interfaces/breadcrumb';

interface IProps {
  title?: string;
  breadcrumb?: IBreadcrumb[] | undefined;
  description?: string;
  back?: boolean;
  show?: boolean;
  isSubmenu?: boolean;
}

export const setLayoutSubheader = ({
  title = '',
  breadcrumb = [],
  description = '',
  back,
  show = false,
  isSubmenu = false,
}: IProps) => {
  LayoutSubheader({ title, breadcrumb, description, back, show, isSubmenu });
};

export const setLayoutFooter = ({
  show = true
}: IProps) => {
  return (LayoutFooter({ show }))
}
